import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { reduxForm } from 'redux-form'

import Footer from '../components/common/Footer'
import Header from '../components/common/Header'
import ModalPopup from '../components/common/ModalPopup'
import ReferralSuccessNotification from '../components/community/ReferralSuccessNotification'
import UpdateUserLocationPanel from '../components/location-search/UpdateUserLocationPanel'
import LoginOrJoin from '../components/login/LoginOrJoin'
import ConfirmRegisterForm from '../components/register/ConfirmRegister'
import SlackBotSuccessModal from '../components/slack/SlackBotSuccessModal'
import GenericSuccessModal from '../components/success-modal/GenericSuccessModal'
import { notificationAck } from '../redux/modules/notification'
import { loadProfileStart } from '../redux/modules/profile'
import {
  isSelectedDeliveryDateActive,
  selectCurrentLocationWithAddress,
  selectUserLocationId,
} from '../redux/modules/selectors'
import { currentUserStart, logoutStart } from '../redux/modules/user'
import { noLocationRoute, selectLocationRoute } from '../routes/routes'

export const ConfirmRegisterContainer = reduxForm({ form: 'confirmpassword' })(ConfirmRegisterForm)

// Jacob Are we still using the logic?
const getRedirect = location => {
  if (location) {
    if (location.locationType === 'GroupOrder') {
      const query = new URLSearchParams()
      const { city, state, street, zip } = location.address
      query.set('address', `${street} ${city}, ${state} ${zip}`)
      return <Redirect to={`${selectLocationRoute.path}?${query.toString()}`} />
    } else if (location.activationDate === null) {
      return <Redirect to={noLocationRoute.path} />
    }
  }
  return null
}
export class LayoutPrivate extends Component {
  componentDidMount() {
    this.props.currentUserStart(true, true)
    this.props.loadProfileStart()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.currentUser && this.props.currentUser) {
      this.props.loadProfileStart()
    }
  }

  render() {
    const {
      children,
      confirmPasswordError,
      confirmPasswordStart,
      currentUser,
      error,
      history,
      isAuthenticated,
      isCurrentUserLoading,
      isSelectedDayActive,
      location,
      match,
      message,
      notificationAck,
      profile,
      requestCount,
      showSubNav,
      submitting,
      userLocationId,
    } = this.props
    const newUser = profile && profile.status !== 'CONFIRMED'
    const redirect = getRedirect(location)

    return (
      <>
        {redirect}
        {/* Asks if you want to change your location permanently when browsing */}
        {userLocationId && location && userLocationId !== location.deliveryLocationId && (
          <UpdateUserLocationPanel locationId={location?.deliveryLocationId} />
        )}
        {/* We don't want to show this modal for inactive/upcoming locations because there is already a sign up form in that page */}
        {/* TODO: We probably want the coming soon page in its own public layout */}
        {!isAuthenticated && isSelectedDayActive && (
          <ModalPopup showCancel={false}>
            <LoginOrJoin
              joinTitle="Register to Order"
              locationId={userLocationId}
              loginMessage="Login to see deliveries and get lunch delivered to your office."
              loginTitle="Login to Order"
              signupMessage="Sign up to see available restaurants and get lunch delivered to your office."
            />
          </ModalPopup>
        )}
        {newUser && (
          <ModalPopup showCancel={false}>
            <ConfirmRegisterContainer
              confirmPasswordError={confirmPasswordError}
              onSubmit={confirmPasswordStart}
              submitting={submitting}
            />
          </ModalPopup>
        )}
        {!isCurrentUserLoading && (
          <Header
            avatarId={profile && profile.avatarId}
            currentUser={currentUser}
            history={history}
            isAuthenticated={isAuthenticated}
            isCurrentUserLoading={isCurrentUserLoading}
            locationId={userLocationId}
            logout={logoutStart}
            match={match}
            profileStatus={profile && profile.status}
            requestCount={requestCount}
            showOffersButton
            showSubNav={showSubNav}
            toggleContentCards={this.toggleContentCards}
          />
        )}
        <SlackBotSuccessModal />
        <ReferralSuccessNotification />
        <GenericSuccessModal isError={error} message={message} notificationAck={notificationAck} />
        {children}
        <Footer isAuthenticated={isAuthenticated} showLogo="true" />
      </>
    )
  }
}

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  const userLocationId = selectUserLocationId(state)
  const isSelectedDayActive = isSelectedDeliveryDateActive(state)
  const { error, message } = state.notification
  const { profile } = state.profile
  const {
    confirmPasswordError,
    currentUser,
    isAuthenticated,
    isCurrentUserLoading,
    submitting,
  } = state.user

  return {
    confirmPasswordError,
    currentUser,
    error,
    isAuthenticated,
    isCurrentUserLoading,
    isSelectedDayActive,
    location,
    message,
    profile,
    submitting,
    userLocationId,
  }
}

const mapDispatchToProps = {
  currentUserStart,
  loadProfileStart,
  logoutStart,
  notificationAck,
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutPrivate)
